import { HitStatusCategory } from '../hit-status-categories/hit-status-category.interface';

export interface HitStatusType {
   id: number;
   name: string;
   key: HitStatusTypeKey;
   hit_status_category_id: number;

   hit_status_category?: HitStatusCategory;
   icon: string;
   color: string;
   rank: number;
}

export enum HitStatusTypeKey {
   PositionToCandidate = 'position-to-candidate',
   CustomerToCandidate = 'customer-to-candidate',
   CandidateToTeam = 'candidate-to-team',
   CandidateToCustomer = 'candidate-to-customer',
   Application = 'application',
   ApplicantContacted = 'applicant-contacted',
   Screening = 'screening',
   Testing = 'testing',
   InterviewAtCompany = 'interview-at-company',
   MedicalExamination = 'medical-examination',
   TestdayAtCustomer = 'testday-at-customer',
   ContractProposal = 'contract-proposal',
   Starter = 'starter',
   Closed = 'closed',
}
